import React, { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { YearDropdown, HeaderContent, SummaryTable } from 'templates';
import { Headings, Button, Disclaimer } from '@sentara-health/optimahealth_web';
import { convertToDate, MyPlanTabs, NavigateConst } from 'common';
import { GlobalContext } from 'context';

const ViewTaxSummary = () => {
  const { t } = useTranslation();
  const year: number = new Date().getFullYear();
  const navigate = useNavigate();

  const [memberValue, setMemberValue] = useState<any>('');
  const [yearValue, setYearValue] = useState<any>(year);
  const [phoneNumber, setPhoneNumber] = useState<any>({});
  const { serviceNumber, getFeature } = useContext(GlobalContext);

  useEffect(() => {
    (async () => {
      try {
        let phoneNumber = JSON.parse(serviceNumber ?? '{}');
        setPhoneNumber(phoneNumber);
      } catch (error) {
        console.error('Error parsing serviceNumber:', error);
      }
    })();
  }, [serviceNumber]);

  const formattedVal = convertToDate(new Date());

  return (
    <>
      <div className="d-flex" data-testid="taxYearSummaryHeading">
        <div className="col-12">
          <div className="row">
            <div className="col-md-8 col-12">
              <div className="mb-3 flex-1">
                <Headings
                  level={1}
                  text={t('viewTaxSummary.taxYearSummary')}
                  variant="semiBold"
                  dataTestId="authorization_header"
                />
              </div>
            </div>
            <div className="col-md-4 col-12 mb-3">
              <YearDropdown
                setMemberValue={setMemberValue}
                yearValue={yearValue}
                setYearValue={setYearValue}
              />
            </div>
          </div>
        </div>
      </div>

      <HeaderContent
        benefitPhone={phoneNumber?.data?.benefitPhone1800}
        benefitPhoneLocal={phoneNumber?.data?.benefitPhoneLocal}
      />
      <SummaryTable summaryDetails={yearValue && memberValue} />
      <div className="mb-3">
        <Disclaimer
          disclaimerContent={`${t(
            'common.disclaimerMsg1'
          )} ${formattedVal}. ${t('common.disclaimerMsg2')}`}
        />
      </div>
      <div className="row">
        <div className="col-md-auto ccol-12 mb-4 pb-2">
          <Button
            dataTestId={'viewIndividualClaims'}
            variant="primary_btn"
            type="submit"
            onClick={() => navigate('/home/medical-claims')}
          >
            {t('viewTaxSummary.viewIndividualClaims')}
          </Button>
        </div>
        {getFeature?.ViewAnnualDeductiblesandMaximums ? (
          <div className="col-md-auto col-12 mb-4 pb-2">
            <Button
              dataTestId={'viewAnnualDeductiblesandMaximums'}
              variant="primary_btn"
              onClick={() =>
                navigate(`${NavigateConst.myPlan + MyPlanTabs.overViewID}`)
              }
              type="submit"
            >
              {t('viewTaxSummary.viewAnnualDeductiblesandMaximums')}
            </Button>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default ViewTaxSummary;
